import React from "react";
import { motion } from "framer-motion";
import { Download, Image, FileText, Music2 } from "lucide-react";
import SectionTitle from "./SectionTitle";
import { toast } from "sonner";

const items = [
  { icon: FileText, title: "Dossier de presse", desc: "Biographie complète, faits marquants, citations." },
  { icon: Image, title: "Photos HD", desc: "Pack de photos haute résolution libres de droits." },
  { icon: Music2, title: "Fiche technique", desc: "Rider technique & configuration de scène." },
];

export const Press = () => (
  <section id="presse" className="section bg-[#050505] py-28">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <SectionTitle kicker="Presse" title="Espace professionnel" testid="press-title" />

      <div className="grid gap-5 md:grid-cols-3">
        {items.map((it, i) => (
          <motion.div
            key={it.title}
            data-testid={`press-item-${i}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="glass group flex flex-col rounded-2xl p-7"
          >
            <it.icon size={30} className="mb-5 text-electric" />
            <h3 className="mb-2 font-display text-xl font-bold text-white">{it.title}</h3>
            <p className="mb-6 flex-1 font-body text-sm text-white/60">{it.desc}</p>
            <button
              data-testid={`press-download-${i}`}
              onClick={() => toast.info("Fichier bientôt disponible", { description: "Le kit presse sera mis en ligne prochainement." })}
              className="flex items-center gap-2 font-heading text-sm font-semibold text-white/80 transition-colors group-hover:text-white"
            >
              <Download size={16} /> Télécharger
            </button>
          </motion.div>
        ))}
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-2xl bg-gradient-to-r from-electric/20 to-neon/20 p-7">
        <div>
          <h3 className="font-display text-xl font-bold text-white">Logos & assets</h3>
          <p className="font-body text-sm text-white/60">Pack complet du logo OLI.VERO (PNG, SVG, versions monochromes).</p>
        </div>
        <button
          data-testid="press-logos-download"
          onClick={() => toast.info("Pack logos bientôt disponible")}
          className="btn-glow flex items-center gap-2 rounded-full bg-white px-6 py-3 font-heading text-sm font-semibold text-black"
        >
          <Download size={16} /> Pack complet
        </button>
      </div>
    </div>
  </section>
);

export default Press;
